import { useEffect, useState } from "react"

import { useUtilities } from "@/modules/cms/views/post/components/builder/context"

const UtilitiesSidebarAnimation = ({ children }) => {
  const { selectedUtilities, setSelectedUtilities } = useUtilities()
  const [translateClass, setTranslateClass] = useState('')
  const [internalUtilities, setInternalUtilities] = useState([])

  useEffect(() => {
    if (selectedUtilities.length !== internalUtilities.length) {
      animation()
    }
  }, [internalUtilities, selectedUtilities])

  useEffect(() => {
    setInternalUtilities(selectedUtilities)
  }, [selectedUtilities])

  useEffect(() => {
    setSelectedUtilities([])
  }, [setSelectedUtilities])

  const animation = () => {
    setTranslateClass('translate-x-full!')

    setTimeout(() => {
      setTranslateClass('translate-x-full!');
    }, ANIMATION_DELAY)

    setTimeout(() => {
      setTranslateClass('')
    }, ANIMATION_DELAY)
  }

  return <div className={`transition-[translate] duration-[${ANIMATION_DURATION}ms] ease-in-out ${translateClass}`} >
    {children}
  </div>
}

const ANIMATION_DURATION = 400
const ANIMATION_DELAY = 500

export default UtilitiesSidebarAnimation
